import { useApi } from '@repo-level/core-front';
import type { ICMSPumpkinRush } from 'api/cms/pumpkinRush';
import { pumpkinRush } from 'api/cms/pumpkinRush';
import type { FC } from 'react';
import { createContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IPumpkinRushContext {
  pumpkinRushData: ICMSPumpkinRush | null;
  pumpkinRushPending: boolean;
}

export const PumpkinRushContext = createContext<IPumpkinRushContext>({
  pumpkinRushData: null,
  pumpkinRushPending: false,
});

export const PumpkinRushContextProvider: FC = ({ children }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const [requestPumpkinRush, { data, pending }] = useApi(pumpkinRush);

  useEffect(() => {
    requestPumpkinRush(language);
  }, [language, requestPumpkinRush]);

  const contextValue = useMemo(
    () => ({
      pumpkinRushData: data ?? null,
      pumpkinRushPending: pending,
    }),
    [data, pending]
  );

  return (
    <PumpkinRushContext.Provider value={contextValue}>
      {children}
    </PumpkinRushContext.Provider>
  );
};
